export class Constants{
  public static isLoading: boolean = false;
  public static config:any = {};
  public static user: string = 'Test_user';
}
